import type { TContactsFormFields } from 'src/client/entities/creditForm';

export const ContactsInfoTexts: Record<keyof TContactsFormFields, string> = {
  mobilePhone: 'Номер телефона',
  email: 'Электронная почта',
  userAgreement: 'Согласие на обработку данных',
  advertisingAgreement: 'Согласие на получение рекламы',
};

export const userAgreementText = {
  link: 'Согласие на обработку данных',
};

export const advertisingAgreementText = {
  link: 'Согласие на рекламу',
};

export const ContactsInfoModalTexts = {
  title: 'Контакты',
  description: 'Проверьте, что всё верно, и внесите изменения',
};
